import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-929">
    <App data-id="element-930" />
  </BrowserRouter>, document.getElementById('root'));